<div class="container">
    <a  [routerLink]="['../../lists/partners-list']"><app-drop-down-arrow class="back-arrow" [size]="'large'" [pointLeft]="true"></app-drop-down-arrow></a>
    <h1>{{ partner?.name }}</h1>
</div>